import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, modalId: String }

  async cancel(event) {
    event.preventDefault()

    const button = event.currentTarget
    const originalText = button.innerHTML
    button.disabled = true
    button.innerHTML = `<span class="far fa-spinner-third fa-spin" aria-hidden="true"></span> ${i18n.t("js.back.cancel_subscription.cancelling")}`

    try {
      const response = await fetch(this.urlValue, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        },
        credentials: "same-origin",
      })

      if (response.ok) {
        // Close modal
        const modalElement = document.getElementById(this.modalIdValue)
        if (modalElement) {
          const modal = bootstrap.Modal.getInstance(modalElement)
          if (modal) {
            modal.hide()
          }
        }

        // Show success flash
        if (App?.displayFlash) {
          App.displayFlash("success", i18n.t("js.back.cancel_subscription.success"))
        }

        // Reload the subscription table
        const turboFrame = document.querySelector("turbo-frame#subscription_orders")
        if (turboFrame) {
          turboFrame.reload()
        }
      } else {
        const error = await response.json()
        if (App?.displayFlash) {
          App.displayFlash("error", error.error || i18n.t("js.back.cancel_subscription.error"))
        }
        button.disabled = false
        button.innerHTML = originalText
      }
    } catch {
      if (App?.displayFlash) {
        App.displayFlash("error", i18n.t("js.back.cancel_subscription.error"))
      }
      button.disabled = false
      button.innerHTML = originalText
    }
  }
}
